import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { RootComponent } from "./components/root/root.component";
import { TableroComponent } from "./components/tablero/tablero.component";
import { SidebarSectionComponent } from "./components/sidebar-section/sidebar-section.component";
import { MapasModule } from "../modules/mapas/mapas.module";
import { LoginModule } from "../modules/login/login.module";
import { environment } from "src/environments/environment.prod";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { ObrasModule } from "../modules/obras/obras.module";
import { SharedModule } from "../shared/shared.module";
import { BusquedasModule } from "../modules/busquedas/busquedas.module";
import { AgmCoreModule } from "@agm/core";
import { AdministracionModule } from "../modules/administracion/administracion.module";
import { CarpetaEjecutivaModule } from "../modules/carpeta-ejecutiva/carpeta-ejecutiva.module";
import { RouterModule } from "@angular/router";
import { TerminosYCondicionesComponent } from "./components/terminos-y-condiciones/terminos-y-condiciones.component";
import { ListaDireccionesComponent } from "./components/lista-direcciones/lista-direcciones.component";
import { ListaModulosPrincipalesComponent } from "./components/lista-modulos-principales/lista-modulos-principales.component";
import { ToastModule } from "primeng/toast";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { SeleccionModulosComponent } from "./components/seleccion-modulos/seleccion-modulos.component";
import { LayoutHeaderComponent } from "./components/layout-header/layout-header.component";
import { CatalogosModule } from "../modules/catalogos/catalogos/catalogos.module";
import { PresupuestosModule } from "../modules/presupuestos/presupuestos.module";
import { TableroPresupuestoComponent } from "./components/tablero-presupuesto/tablero-presupuesto.component";
import { TooltipModule } from "primeng/tooltip";
import { DashboardadminModule } from '../dashboardadmin/dashboardadmin.module';

@NgModule({
  declarations: [
    RootComponent,
    TableroComponent,
    SidebarSectionComponent,
    TerminosYCondicionesComponent,
    ListaDireccionesComponent,
    ListaModulosPrincipalesComponent,
    SeleccionModulosComponent,
    LayoutHeaderComponent,
    TableroPresupuestoComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AgmCoreModule.forRoot({
      apiKey: environment.apiKeyGoogleCloud,
      libraries: ["geometry"],
    }),
    LoginModule,
    MapasModule,
    ObrasModule,
    SharedModule,
    BusquedasModule,
    AdministracionModule,
    CarpetaEjecutivaModule,
    CatalogosModule,
    ToastModule,
    MessagesModule,
    MessageModule,
    PresupuestosModule,
    TooltipModule,
  ],
  providers: [],
  bootstrap: [RootComponent],
})
export class AppModule {}
